 
import * as serviceWorkerRegistration from "./src/serviceWorkerRegistration";
import { StatusBar as ExpoStatusBar } from 'expo-status-bar';
import { ThemeProvider } from 'styled-components/native';
import { theme } from './src/infrastructure/theme';
import React from 'react';
import { Navigation } from './src/infrastructure/navigation';
import { Provider } from 'react-native-paper';
import { LocationContextProvider } from './src/context/results.context';
import { GraphContextProvider } from './src/context/graph.context';

export default function App() {
  // const [abelLoaded] = useAbel({
  //   Abel_400Regular,
  // });

  // if (!abelLoaded) {
  //   return null;
  // }
  return (
    <>
      <Provider>
        <ThemeProvider theme={theme}>
          <LocationContextProvider>
            <GraphContextProvider>
              <Navigation />
            </GraphContextProvider>
          </LocationContextProvider>
        </ThemeProvider>
        <ExpoStatusBar style="auto" />
      </Provider>
    </>
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// serviceWorkerRegistration.register('service-worker.js', { enabled: environment.production, scope: '/', registrationStrategy: 'registerImmediately'});

